var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"font-bold text-white bg-primary rounded-3xl px-8 py-2 w-full"},[_c('span',{staticClass:"flex justify-center items-center rtl:mt-0.5"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }